<template>
  <div>
    <div class="main-content">
      <div style="display:flex;padding: 8px 16px 0 16px;">
        <div class="filters">
          <el-form :inline="true" label-width="80px" label-position="left" @submit.native.prevent>
            <div class="el-form-item-wrapper">
              <el-form-item>
                <div slot="label" style="text-align: center;">{{ $t('SeaExport.opOffice') }}</div>
                <cargo-advance-select
                  :select-type="selectTypeNames.basic_data_Office_All"
                  filterable
                  :multiple="true"
                  :default-multiple-value="from.multipleOfficeIdList || []"
                  tag-name="code"
                  style="width: 230px"
                  @parentCallBack="p=>{from.multipleOfficeIdList=p.value}"
                />
              </el-form-item>
              <el-form-item>
                <div slot="label" style="text-align: center;">{{ $t('CargoMsg.Cargo_BusinessType') }}</div>
                <el-select v-model="from.lob" style="width: 230px" clearable @change="multipleLobChange">
                  <el-option
                    v-for="(item, index) in lobs"
                    :key="index"
                    :value="item.code"
                    :label="item.chineseName"
                  />
                </el-select>
              </el-form-item>
              <el-form-item>
                <div slot="label" style="text-align: center;">{{ $t('SystemMaintenance.PushingLink') }}</div>
                <el-select v-model="from.pushLink" style="width: 230px" clearable>
                  <el-option
                    v-for="(item, index) in pushFilterList"
                    :key="index"
                    :value="item.id"
                    :label="item.name"
                  />
                </el-select>
              </el-form-item>
              <el-form-item>
                <div slot="label" style="text-align: center;">{{ $t('CargoMsg.Cargo_Recipient') }}</div>
                <cargo-advance-select
                  :select-type="selectTypeNames.local_cache_SystemConstants$LOBS"
                  filterable
                  :multiple="true"
                  :static-options="accountList"
                  :default-multiple-value="from.multipleAccountIdList || []"
                  :tag-name="isZh ? 'chineseName' : 'englishName'"
                  tag-value="code"
                  style="width: 230px"
                  @parentCallBack="p=>{from.multipleAccountIdList=p.value}"
                />
              </el-form-item>
            </div>
          </el-form>
        </div>
        <div class="triggers">
          <el-button type="primary" @click="getListData">{{ $t('CargoMsg.Cargo_Query') }}</el-button>
          <el-button type="primary" :disabled="!$checkPermission(['role_emailTemplate_add'])" @click="toAdd">{{ $t('CargoMsg.Cargo_NewTo') }}</el-button>
          <el-button type="primary" :disabled="!$checkPermission(['role_emailTemplate_editable'])" @click="toView">{{ $t('common.btn.edit') }}</el-button>
          <el-button type="danger" :disabled="!$checkPermission(['role_emailTemplate_delete'])" @click="toDelete">{{ $t('CargoMsg.Cargo_OrderDelete') }}</el-button>
        </div>
      </div>
      <div class="main-content">
        <div class="section grid-wrapper">
          <cargo-ag-grid
            config-module="195625"
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :row-data="rowData"
          />
        </div>
      </div>
    </div>
    <!-- 编辑弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="emailEditingAccording"
      :close-on-click-modal="false"
      :title="$t('SystemMaintenance.EmailTemplateEditing')"
      width="1100px"
    >
      <el-form :model="emailEditing" label-width="120px" label-position="right">
        <div class="el-form-item-wrapper">
          <div style="display: flex; padding-bottom: 10px">
            <span class="edit-email-title" style="top: 57px;" />
            <span style="padding-left: 40px; font-size: 15px">{{ $t('CargoMsg.Cargo_BusinessApplicationContext') }}</span>
          </div>
          <div style="display: flex;padding-left: 41px;border-bottom: 1px solid #E3E3E3;padding-bottom: 10px">
            <el-form-item label-width="80px">
              <div slot="label" style="text-align: center;">{{ $t('SeaExport.opOffice') }}</div>
              <cargo-advance-select
                :select-type="selectTypeNames.basic_data_Office_All"
                filterable
                :multiple="true"
                :default-multiple-value="emailEditing.multipleOfficeIdList || []"
                tag-name="code"
                style="width: 150px"
                @parentCallBack="p=>{emailEditing.multipleOfficeIdList=p.value}"
              />
            </el-form-item>
            <el-form-item label-width="80px">
              <div slot="label" style="text-align: center;">{{ $t('CargoMsg.Cargo_BusinessType') }}</div>
              <el-select v-model="emailEditing.lob" clearable @change="lobChange">
                <el-option
                  v-for="(item, index) in lobs"
                  :key="index"
                  :value="item.code"
                  :label="item.chineseName"
                />
              </el-select>
            </el-form-item>
            <el-form-item label-width="80px">
              <div slot="label" style="text-align: center;">{{ $t('SystemMaintenance.PushingLink') }}</div>
              <el-select v-model="emailEditing.pushLink" style="width: 150px" clearable @change="pushListChange">
                <el-option
                  v-for="(item, index) in pushList"
                  :key="index"
                  :value="item.id"
                  :label="item.name"
                />
              </el-select>
            </el-form-item>
            <el-form-item label-width="80px">
              <div slot="label" style="text-align: center;">{{ $t('CargoMsg.Cargo_Recipient') }}</div>
              <cargo-advance-select
                :select-type="selectTypeNames.local_cache_SystemConstants$LOBS"
                filterable
                :disabled="emailEditing.pushLink === '16' || emailEditing.pushLink === '17' || isBbSendDestinationPortAgent"
                :multiple="true"
                :static-options="accountList"
                :default-multiple-value="emailEditing.multipleAccountIdList || []"
                :tag-name="isZh ? 'chineseName' : 'englishName'"
                tag-value="code"
                style="width: 166px"
                @parentCallBack="p=>{emailEditing.multipleAccountIdList=p.value}"
              />
            </el-form-item>
          </div>

          <div style="display: flex; padding-top: 15px; padding-bottom: 10px">
            <span class="edit-email-title" style="top: 145px;" />
            <span style="padding-left: 40px; font-size: 15px">{{ $t('CargoMsg.Cargo_ConfigureEmailTemplate') }}</span>
            <span v-if="['19','20','21'].includes(emailEditing.pushLink)" style="padding-left: 10px; font-size: 14px">
              <el-tooltip>
                <i class="el-icon-warning" style="color: #e6a23c;margin-left: 5px" />
              </el-tooltip>
              <label>{{ $t('SystemMaintenance.SendEmailByPositionPersonnel') }}</label>
            </span>
          </div>
          <el-form-item :label="$t('CargoMsg.Cargo_Email2') + $t('Template.TemplateName')">
            <el-input ref="templateName" v-model="emailEditing.templateName" />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_SendingPosition')">
            <el-checkbox v-model="emailEditing.sales">{{ $t('SeaExport.Sales') }}</el-checkbox>
            <el-checkbox v-model="emailEditing.op">{{ $t('SeaExport.Operation') }}</el-checkbox>
            <el-checkbox v-model="emailEditing.csr">{{ $t('SeaExport.CustomerService') }}</el-checkbox>
            <el-checkbox v-model="emailEditing.doc">{{ $t('SeaExport.Documents') }}</el-checkbox>
            <el-checkbox v-model="emailEditing.siteOP" no="siteOP">{{ $t('SeaExport.FieldOperation') }}</el-checkbox>
            <el-checkbox v-model="emailEditing.overseaOp" no="overseaOp">{{ $t('SeaExport.OverseaCustomerService') }}</el-checkbox>
            <el-checkbox v-model="emailEditing.planner" no="planner">{{ $t('SeaExport.AirlinePerson2') }}</el-checkbox>
            <el-checkbox v-model="emailEditing.userDefinedRoleId1" no="userDefinedRoleId1">{{ $t('CargoMsg.Cargo_userDefinedRole1') }}</el-checkbox>
            <el-checkbox v-model="emailEditing.userDefinedRoleId2" no="userDefinedRoleId2">{{ $t('CargoMsg.Cargo_userDefinedRole2') }}</el-checkbox>
            <el-checkbox v-if="!(['19','20','21'].includes(emailEditing.pushLink))" v-model="emailEditing.emailGroup">{{ $t('SeaExport.EmailGroup') }}</el-checkbox>
          </el-form-item>

          <el-form-item v-if="emailEditing.emailGroup" :label="$t('SeaExport.Cc') + $t('SeaExport.EmailGroup')">
            <el-select
              v-model="emailEditing.emailGroupCcList"
              filterable
              multiple
              clearable
            >
              <el-option
                v-for="(item, index) in emailGroupCcList"
                :key="index"
                :label="item.groupName"
                :value="item.uuid"
              />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('SeaExport.emailSubject')">
            <el-input ref="themeTemplate" v-model="emailEditing.themeTemplate" @focus="eFocus=constant.eFocus.emailTitle" @blur="blurEvent" />
          </el-form-item>
          <el-form-item :label="$t('SystemMaintenance.TextTemplate')">
            <cargo-editor
              v-model="emailEditing.contentTemplate"
              :placeholder="$t('SystemMaintenance.PleaseAProductDescriptionHere')"
              style="height: 400px;"
              @onCreated="p=>{editor=p}"
            />
          </el-form-item>
          <el-form-item :label="$t('SystemMaintenance.DataItem')">
            <div style="display: flex; margin-bottom: 10px;width:66%;">
              <div ref="dataItemTabs" class="outside">
                <div style="position:relative;" @click="spread">
                  <div class="outside-value">{{ showName }}</div>
                  <i class="el-icon-arrow-down icon" :class="{'rotatingShow': isShow, 'rotatingHide': !isShow }" />
                </div>
                <div v-show="isShow" class="operation" style="z-index: 100;">
                  <div v-for="(item, index) in dataItemTabs" v-show="item.code===SE_FILE_INFORMATION.code?emailEditing.pushLink==='16'||emailEditing.pushLink==='17'||isBbSendDestinationPortAgent:true" :key="index" class="item" :class="{'set-color': value === item.code, 'set-bgc': index === 0}" @click="selectItem(item)">
                    <span>{{ isZh ? item.chineseName : item.englishName }}</span>
                    <div v-show="dataItemTab === item.code" class="dataItem">
                      <span
                        v-for="(item, itemIndex) in dataItems"
                        :key="itemIndex"
                        class="item"
                        :class="{itemChoose:chooseId === itemIndex}"
                        @click.stop="onClickSopDataItemByContent(item.chineseName, itemIndex)"
                      >{{ item.chineseName }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <cargo-advance-select
                :static-options="dataItems"
                :placeholder="$t('CargoMsg.Cargo_SearchForTheDataYouWantToInsert')"
                :cache="false"
                style="width: 320px;"
                filter-type="global"
                filterable
                clearable
                tag-value="chineseName"
                @parentCallBack="changeDataItem"
                @focus="dataItemFocusEvent"
              />
              <template v-if="emailEditing.pushLink === '16' || emailEditing.pushLink === '17' || isBbSendDestinationPortAgent">
                <div style="display: flex;">
                  <span class="edit-email-title" style="left: unset;top: 8px;margin-left: 10px;" />
                  <span style="padding-left: 20px">{{ $t('SystemMaintenance.AutoPrintRule') }}</span>
                </div>
              </template>
            </div>
          </el-form-item>
          <el-form-item :label="$t('SystemMaintenance.MailServer')">
            <el-select v-model="emailEditing.mailServerType" style="width: 320px;">
              <el-option
                v-for="(item, index) in mailServers"
                :key="index"
                :value="item.code"
                :label="item.chineseName"
              />
            </el-select>
            <div v-show="emailEditing.mailServerType===1" style="margin-left: 10px;display: inline-block;">
              <i class="el-icon-warning" style="color: #E6A23C;font-size: 14px;margin-right: 5px;line-height: 18px;" />
              <span style="line-height: 18px;">
                {{ $t('SystemMaintenance.PushConfigServiceCompanyEmail') }}
              </span>
            </div>
          </el-form-item>
          <template v-if="emailEditing.pushLink === '16' || emailEditing.pushLink === '17'">
            <el-form-item :label="$t('SystemMaintenance.MainTicketAttachmentItem')">
              <div style="display: flex;align-items: start;">
                <el-button type="primary" style="width: 100px;margin-right: 10px;border-radius: 5px;" @click="onMasterSelectFileType">{{ $t('SystemMaintenance.SelectFileType') }}</el-button>
                <el-input :value="masterFileCategoryLabel" disabled type="textarea" :rows="3" style="width: 320px;margin-right: 10px;" />
                <div style="width: 100px;margin-top: -7px;">
                  <el-checkbox v-model="emailEditing.autoGenerationManifest" style="margin-top: -7px;" @change="onAutoGenerationManifest">{{ $t('SystemMaintenance.AutoGenerationManifestLabel') }}</el-checkbox>
                  <el-checkbox v-model="emailEditing.autoPrintManifestAfterAllHblConfirm" :disabled="!emailEditing.autoGenerationManifest" class="checkbox-multiple" style="margin-top: -7px;">
                    {{ $t('SystemMaintenance.TheStatusOfAllProcesses') }}
                    <br>
                    {{ $t('SystemMaintenance.WhenOnlyAfterTheConfirmed') }}
                  </el-checkbox>
                  <el-checkbox v-model="emailEditing.hblWithoutGenerateAttach" style="margin-top: -7px;" @change="onHblWithoutGenerateAttachChange">{{ $t('SystemMaintenance.HblWithoutGenerateAttachLabel') }}</el-checkbox>
                  <el-checkbox v-model="emailEditing.confirmedPrintHbl" style="margin-top: -7px;">{{ $t('SystemMaintenance.ConfirmedPrintHblLabel') }}</el-checkbox>
                </div>
              </div>
            </el-form-item>
            <el-form-item :label="$t('SystemMaintenance.SmallTicketAttachmentItem')">
              <div style="display: flex;align-items: start;">
                <el-button type="primary" style="width: 100px;margin-right: 10px;border-radius: 5px;" @click="onSalveSelectFileType">{{ $t('SystemMaintenance.SelectFileType') }}</el-button>
                <el-input :value="slaveFileCategoryLabel" disabled type="textarea" :rows="4" style="width: 320px;margin-right: 10px;" />
                <div style="width: 150px;margin-top: -7px;">
                  <div style="display: flex;">
                    <span class="edit-email-title" style="left: unset;top: 0" />
                    <span style="padding-left: 10px">{{ $t('SystemMaintenance.EmailAttachRule') }}</span>
                  </div>
                  <el-checkbox v-model="emailEditing.includeSlaveAttach">{{ $t('SystemMaintenance.IncludeSlaveAttachLabel') }}</el-checkbox>
                  <el-checkbox v-model="emailEditing.businessIfVirtualBillAsAttachment" @change="onBusinessIfVirtualBillAsAttachment">{{ $t('SystemMaintenance.BusinessOrdersAttachments') }}</el-checkbox>
                  <el-checkbox v-model="emailEditing.hblCfmStateOriginDraft">{{ $t('SystemMaintenance.HblCfmStateOriginDraftLabel') }}</el-checkbox>
                  <el-checkbox v-model="emailEditing.hblBlWayAttach" @change="onHblBlWayAttachChange">{{ $t('SystemMaintenance.HblBlWayAttachLabel') }}</el-checkbox>
                  <el-checkbox v-model="emailEditing.whenBillNotStartWithoutAttachment">{{ $t('SystemMaintenance.BillNotStartNoneFile') }}</el-checkbox>
                  <template v-if="emailEditing.pushLink === '16'">
                    <div style="display: flex;">
                      <span class="edit-email-title" style="position: unset;margin-top: 8px;" />
                      <span style="padding-left: 5px">{{ $t('SystemMaintenance.FormalDivisionRule') }}</span>
                    </div>
                    <el-checkbox v-model="emailEditing.businessIfVirtualBillOnlyAttachment" :disabled="!emailEditing.businessIfVirtualBillAsAttachment">{{ $t('SystemMaintenance.BusinessIfVirtualBillOnlyAttachment') }}</el-checkbox>
                  </template>
                  <template>
                    <div style="display: flex;width: 400px;">
                      <span class="edit-email-title" style="position: unset;margin-top: 8px;" />
                      <span style="padding-left: 5px">{{ $t('SystemMaintenance.WhenIssuesBillOfExtracted') }}</span>
                    </div>
                    <el-checkbox v-model="emailEditing.takeWhenHasCustomerBillConfirm">{{ $t('SystemMaintenance.WhenLadingHasBeenDocuments') }}</el-checkbox>
                    <el-checkbox v-model="emailEditing.takeWhenHasCustomerBillNotConfrim">{{ $t('SystemMaintenance.WhenIsNeitherConfirmedExtracted') }}</el-checkbox>
                    <el-checkbox v-model="emailEditing.autoPrintWhenNoneCustomerBillConfirm">{{ $t('SystemMaintenance.WhenOfLadingHasSample') }}</el-checkbox>
                  </template>
                </div>
              </div>
            </el-form-item>
            <el-form-item v-if="emailEditing.pushLink === '16'" label-width="0" style="margin-top: -95px">
              <span style="margin-left: 50px;color: black;">{{ $t('SystemMaintenance.LockAfterSend') }}</span>
              <el-checkbox v-model="emailEditing.sendLockSlaveHblAndVirtualBill">{{ $t('SystemMaintenance.SendLockSlaveHblAndVirtualBill') }}</el-checkbox>
            </el-form-item>
            <el-form-item v-if="emailEditing.pushLink === '17'" label-width="0" style="margin-top: -95px">
              <span style="margin-left: 50px;color: black;">{{ $t('SystemMaintenance.LockAfterSend') }}</span>
              <el-checkbox v-model="emailEditing.sendLockExchangeAgentHblAndVirtualBill">{{ $t('SystemMaintenance.SendLockExchangeAgentHblAndVirtualBill') }}</el-checkbox>
            </el-form-item>
            <el-form-item>
              <div style="margin-top: 35px;display: flex">
                <i class="el-icon-warning" style="color: #E6A23C;font-size: 14px;margin-right: 5px;line-height: 18px;" />
                <span style="line-height: 18px;">
                  {{ $t('SystemMaintenance.FileAttachmentTip') }}
                  <!--                  <br>-->
                  <!--                  {{ $t('SystemMaintenance.FileAttachmentTip2') }}-->
                </span>
              </div>
            </el-form-item>
          </template>
          <!--委托拼箱发送目的港代理文件-->
          <template v-if="isBbSendDestinationPortAgent">
            <el-form-item :label="$t('SystemMaintenance.AttachmentItems')">
              <div style="display: flex;align-items: start;">
                <el-button no="SelectFileType" type="primary" style="width: 100px;margin-right: 10px;border-radius: 5px;" @click="onSelectFileType">{{ $t('SystemMaintenance.SelectFileType') }}</el-button>
                <el-input no="fileCategoryLabel" :value="fileCategoryLabel" disabled type="textarea" :rows="3" style="width: 320px;margin-right: 10px;" />
                <div style="width: 150px;margin-top: -7px;">
                  <el-checkbox v-model="emailEditing.hblWithoutGenerateAttach" no="hblWithoutGenerateAttach" style="margin-top: -7px;" @change="onHblWithoutGenerateAttachChange">{{ $t('SystemMaintenance.HblWithoutGenerateAttachLabel') }}</el-checkbox>
                  <el-checkbox v-model="emailEditing.confirmedPrintHbl" no="confirmedPrintHbl" style="margin-top: -7px;">{{ $t('SystemMaintenance.ConfirmedPrintHblLabel') }}</el-checkbox>
                  <template>
                    <div style="display: flex;">
                      <span class="edit-email-title" style="left: unset;top: 55px" />
                      <span style="padding-left: 10px">{{ $t('SystemMaintenance.EmailAttachRule') }}</span>
                    </div>
                    <el-checkbox v-model="emailEditing.hblCfmStateOriginDraft" no="hblCfmStateOriginDraft">{{ $t('SystemMaintenance.HblCfmStateOriginDraftLabel') }}</el-checkbox>
                    <el-checkbox v-model="emailEditing.hblBlWayAttach" no="hblBlWayAttach" @change="onHblBlWayAttachChange">{{ $t('SystemMaintenance.HblBlWayAttachLabel') }}</el-checkbox>
                    <el-checkbox v-model="emailEditing.whenBillNotStartWithoutAttachment" no="whenBillNotStartWithoutAttachment">{{ $t('SystemMaintenance.BillNotStartNoneFile') }}</el-checkbox>
                  </template>
                  <template>
                    <div style="display: flex;width: 400px;">
                      <span class="edit-email-title" style="position: unset;margin-top: 8px;" />
                      <span style="padding-left: 5px">{{ $t('SystemMaintenance.WhenIssuesBillOfExtracted') }}</span>
                    </div>
                    <el-checkbox v-model="emailEditing.takeWhenHasCustomerBillConfirm">{{ $t('SystemMaintenance.WhenLadingHasBeenDocuments') }}</el-checkbox>
                    <el-checkbox v-model="emailEditing.takeWhenHasCustomerBillNotConfrim">{{ $t('SystemMaintenance.WhenIsNeitherConfirmedExtracted') }}</el-checkbox>
                    <el-checkbox v-model="emailEditing.autoPrintWhenNoneCustomerBillConfirm">{{ $t('SystemMaintenance.WhenOfLadingHasSample') }}</el-checkbox>
                  </template>
                </div>
              </div>
            </el-form-item>
            <el-form-item label-width="0" style="margin-top: -95px; height: 100px">
              <span style="margin-left: 50px;color: black;">{{ $t('SystemMaintenance.LockAfterSend') }}</span>
              <el-checkbox v-model="emailEditing.sendLockHblAndVirtualBill" no="sendLockHblAndVirtualBill">{{ $t('SystemMaintenance.SendLockHblAndVirtualBill') }}</el-checkbox>
            </el-form-item>
          </template>
        </div>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="determine">{{ $t('SystemMaintenance.OK') }}</el-button>
        <el-button plain @click="cancel">{{ $t('SystemMaintenance.Cancel') }}</el-button>
        <el-button type="primary" @click="sendTest">{{ $t('SystemMaintenance.SendTest') }}</el-button>
      </div>
    </el-dialog>
    <!-- 二级弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="secondaryConfirmation"
      :close-on-click-modal="false"
      :title="Title"
      width="350px"
    >
      <div v-show="Title === '提示'">{{ dialogContent.text }}</div>
      <div v-show="Title === '发送测试'" style="isplay: flex;align-items: center;justify-content: center;">
        <el-form label-width="100px">
          <el-form-item :label="$t('SystemMaintenance.SendTo')">
            <el-input v-model="sendTestVal" style="width:200px;" />
          </el-form-item>
          <el-form-item :label="$t('SystemMaintenance.SendEmail')" :inline="true">
            <el-checkbox-group v-model="checkList" @change="statusChange()">
              <div v-for="(item,index) in sendEamilArr" :key="index">
                <el-checkbox :label="item" />
              </div>
            </el-checkbox-group>
          </el-form-item>
        </el-form>

      </div>
      <div slot="footer">
        <el-button type="primary" @click="againDetermine">{{ $t('SystemMaintenance.OK') }}</el-button>
        <el-button plain @click="confirmAgain">{{ $t('SystemMaintenance.Cancel') }}</el-button>
      </div>
    </el-dialog>
    <!-- 文件类型选择对话框 -->
    <mx-file-type-editor
      v-if="fileTypeEditor.visible"
      :visible.sync="fileTypeEditor.visible"
      :lob="emailEditing.lob"
      :file-id="fileTypeEditor.fileId"
      :file-category="fileTypeEditor.fileCategory"
      @saveFileType="onSaveFileType"
    />
  </div>
</template>
<script>
import { quillEditor, Quill } from 'vue-quill-editor'
import { ImageExtend } from '@/utils/quill-image-extend-module'
import * as userApi from '@/api/user'
import { cache, cacheName } from '@/utils/cacheManager'
import { DocumentManage, ensureExecuteSuccess } from '@/utils/commonUtil'
import URL from '@/api/urlTranslator'
import { getLoading } from '@/utils/utilBaseElement'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getGridSelected, getGridSelectedIds } from '@/utils/agGrid'
import * as SopDataItemConstants from '@/class/cargo/model/parameters/SopDataItemConstants'
import * as SopDataItemTabConstants from '@/class/cargo/model/parameters/SopDataItemTabConstants'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import CargoEditor from '@/components/Cargo/Common/CargoEditor'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { SopUtil } from '@/class/cargo/model/utils/SopUtil'
import MxFileTypeEditor from '@/components/Cargo/Job/mxFileTypeEditor'
import { getDocCategoryTypeTree } from '@/api/sysManage/baseConfig/docCategory'
import { getMailGroupList } from '@/api/basicData/mailGroup'
import {
  BB_SEND_DESTINATION_PORT_AGENT_STRING, EMAIL_SERVERS_CONFIG,
  MAIL_ACCOUNT_1,
  MAIL_ACCOUNT_5, PUSH_LINK_LIST
} from '@/class/cargo/model/parameters/SystemConstants'
import $store from '@/store'
Quill.register('modules/ImageExtend', ImageExtend)

export default {
  name: 'MailboxManagement',
  components: { CargoAdvanceSelect, quillEditor, MxFileTypeEditor, CargoEditor },
  data() {
    return {
      selectTypeNames: TYPE_NAMES,
      BB_SEND_DESTINATION_PORT_AGENT_STRING,
      value: '基础数据',
      isShow: false,
      isZh() {
        return this.$store.getters.language === 'zh'
      },
      from: {
        val: '',
        multipleOfficeIdList: [],
        lob: '',
        pushLink: '',
        multipleAccountIdList: []
      },
      offices: [],
      accountList: Array.from(SystemConstants.MAIL_ACCOUNT_TYPE),
      lobs: Array.from(SystemConstants.LOBS),
      mailServers: Array.from(SystemConstants.EMAIL_SERVERS_CONFIG),
      dataItemTab: 1,
      dataItemTabs: [],
      rowData: [],
      checkList: [],
      emailId: '0',
      sendEamilArr: ['系统邮箱'],
      chooseId: '',
      snedTestDialogContent: false,
      Title: '发送测试',
      sendTestVal: '',
      documentManage: new DocumentManage(),
      editorOption: {
        modules: {
          ImageExtend: {
            loading: true,
            name: 'image',
            size: 10,
            sizeError: () => {
              this.$message.error(this.$t('SystemMaintenance.PicturePictureMustNot10M'))
            }
          },
          toolbar: {
            container: [
              /* eslint-disable */
              ["bold", "italic", "underline", "strike"], // 加粗 斜体 下划线 删除线
              ["blockquote", "code-block"], // 引用  代码块
              [{ header: 1 }, { header: 2 }], // 1、2 级标题
              [{ size: ["small", false, "large", "huge"] }], // 字体大小
              [{ header: [1, 2, 3, 4, 5, 6, false] }], // 标题
              ["clean"], // 清除文本格式
              ["link", "image"], // 链接、图片
            ],
            handlers: {
              'image': function (value) {
                if (value){
                  document.querySelector('.avatar-uploader input').click()
                } else{
                  this.Quill.format('image',false)
                }
              }
            }
          }
        },
        placeholder: this.$t('SystemMaintenance.PleaseAProductDescriptionHere'), //提示
        readyOnly: false, //是否只读
        theme: 'snow', //主题 snow/bubble
        syntax: true, //语法检测
      },
      uploadInfo: {
        action: '',
        header: {
          enctype: 'multipart/form-data; charset=UTF-8'
        }
      },
      quillUpdateImg:false ,//根据图片上传状态来确定是否显示loading动画，刚开始是false,不显示
      constant: {
        eFocus: { emailTitle: 'emailTitle', emailContent: 'emailContent'}
      },
      eFocus: '', // 获取焦点的元素 （email:标题、文本，msg:标题、文本）
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        onCellDoubleClicked: this.onCellDoubleClicked,
      },
      dialogContent:{
        text: '',
      },
      emailPermissions: true,
      gridParams: {},
      cursor:'',
      blurIndex:'',
      storageURL: '',
      emailEditingAccording: false,// 邮箱模板编辑弹窗显示
      secondaryConfirmation: false,//取消二次确认弹窗显示
      emailGroupCcList: [],
      branchEmail: {}, // 分公司邮箱信息
      emailEditing: {
        uuid: '',
        lob: 'SE',
        pushLink: '',
        themeTemplate: '',
        templateName: '', // 模板名称
        contentTemplate: '',
        dataItemList: [],
        multipleOfficeIdList: [],
        multipleAccountIdList: [],
        mailServerType: 0,
        sales: false,
        op: false,
        csr: false,
        doc: false,
        siteOP: false,
        overseaOp: false,
        planner: false,
        userDefinedRoleId1: false,
        userDefinedRoleId2: false,
        emailGroup: false,
        emailGroupCcList: [],
        masterAttachItems: '',
        includeSlaveAttach: false,
        autoGenerationManifest: false,
        slaveAttachItems: '',
        attachItems: '',
        hblBlWayAttach: false,
        hblWithoutGenerateAttach: false,
        confirmedPrintHbl: false,
        businessIfVirtualBillAsAttachment: false, // 业务有形式分单时，附件抽取形式分单
        hblCfmStateOriginDraft: false,
        whenBillNotStartWithoutAttachment: false, // HBL提单状态未开始或待确认时，不抽取任何提单文件（包括样张件）
        sendLockSlaveHblAndVirtualBill: false, // 发送后，锁定小票的HBL和形式分单页签（包括拆单/并单）
        sendLockExchangeAgentHblAndVirtualBill: false, // 发送后，锁定对应换单代理的HBL页签和形式分单页签（包括拆单/并单）
        autoPrintManifestAfterAllHblConfirm: false, // 仅在所有HBL提单状态都确认后，自动打印MAINFEST文件（包括HBL拆单）
        businessIfVirtualBillOnlyAttachment: false, // 业务有形式分单时，附件仅抽取形式分单文件
        sendLockHblAndVirtualBill: false, // 发送后，锁定业务的HBL和形式分单页签（包括拆单/并单）
        takeWhenHasCustomerBillConfirm: true, // 当有客户自出单文件时，且提单已确认或已签发时，抽取客户自出单
        takeWhenHasCustomerBillNotConfrim: true, // 当有客户自出单文件时，且提单未确认未签发时，不抽取客户自出单
        autoPrintWhenNoneCustomerBillConfirm: true // 当没有客户自出单文件时，且提单已确认未签发，自动打印样张
      },
      contrastData: '',
      isEdit:0, // 是否编辑 0否  1-是
      pushList: PUSH_LINK_LIST,
      spreadData: [
        {
          name: this.$t('SystemMaintenance.BasicData'),
          value:1
        },
        {
          name: this.$t('SystemMaintenance.BookingPageData'),
          value: 2
        }
      ],
      columnDefs: [
        {
          headerName: '',
          width: 55,
          checkboxSelection: true,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false,
          headerCheckboxSelection: true
        }, {
          headerName: this.$t('SystemMaintenance.PushingLink'),
          suppressMenu: true,
          width: 200,
          field: 'pushLinkName'
        }, {
          headerName: this.$t('Template.TemplateName'),
          suppressMenu: true,
          width: 200,
          field: 'templateName'
        }, {
          headerName: this.$t('SystemMaintenance.SubjectTemplate'),
          suppressMenu: true,
          width: 200,
          field: 'themeTemplate'
        }, {
          headerName: this.$t('SystemMaintenance.ContentTemplate'),
          suppressMenu: true,
          width: 200,
          field: 'contentTemplate'
        }, {
          headerName: this.$t('SystemMaintenance.Updater'),
          suppressMenu: true,
          field: 'modifiedByName',
          width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.data.modifiedBy), 'chineseName')
          }
        },
        {
          headerName: this.$t('SeaExport.opOffice'),
          suppressMenu: true,
          field: 'multipleOfficeIdName',
          width: 200
        },
        {
          headerName: this.$t('CargoMsg.Cargo_BusinessType'),
          suppressMenu: true,
          field: 'lob',
          width: 200,
          cellRenderer: (params) => {
            if (params.value) {
              return ColumnUtils.jobBussStateLabelFunc(params.value)
            } else {
              return ''
            }
          }
        },
        {
          headerName: this.$t('SystemMaintenance.PushObject'),
          suppressMenu: true,
          field: 'multipleAccountIdName',
          width: 200
        },{
          headerName: this.$t('SystemMaintenance.LastUpdateTime'),
          suppressMenu: true,
          width: 200,
          field: 'dateModified'
        }
      ],
      fileTypeEditor: {
        visible: false,
        fileId: '',
        fileCategory: '',
        masterFlag: false
      },
      docTypeMap: null,
      masterFileCategoryLabel: '',
      slaveFileCategoryLabel: '',
      fileCategoryLabel: '',
      SE_FILE_INFORMATION: SopDataItemTabConstants.SE_FILE_INFORMATION,
      editor: null
    }
  },
  computed:{
    pushFilterList() {
      if (!this.from.lob) {
        return this.pushList
      }
      const list = []
      // 处理包含 'SE' 的情况
      if (this.from.lob.includes('SE')) {
        list.push(
          { name: this.$t('SystemMaintenance.PreSendingSupplementaryInvitationLink'), id: '1' },
          { name: this.$t('SystemMaintenance.MarineMBLInvitationForProofreading'), id: '2' },
          { name: this.$t('SystemMaintenance.MarineHBLInvitationForProofreading'), id: '3' },
          { name: this.$t('SystemMaintenance.MarineExportBulkPrinting'), id: '4' },
          { name: this.$t('SystemMaintenance.SendDestinationPortProxyDocuments'), id: '16' },
          { name: this.$t('SystemMaintenance.SendPackageProxyFiles'), id: '17' },
          { name: this.$t('SystemMaintenance.BbSendDestinationPortAgent'), id: BB_SEND_DESTINATION_PORT_AGENT_STRING }
        )
      }

      // 处理包含 'SE' 或 'SI' 的情况
      if (this.from.lob.includes(SystemConstants.SE.code) || this.from.lob.includes(SystemConstants.SI.code)) {
        list.push({ name: this.$t('SystemMaintenance.OceanShippingAlertReminderEmail'), id: '10' })
      }

      // 处理包含 'AE' 或 'AI' 的情况
      if (this.from.lob.includes(SystemConstants.AE.code) || this.from.lob.includes(SystemConstants.AI.code)) {
        list.push({ name: this.$t('SystemMaintenance.AirCargoStorage'), id: '5' })
      }

      // 处理包含 'AI' 的情况
      if (this.from.lob.includes(SystemConstants.AI.code)) {
        list.push({ name: this.$t('SystemMaintenance.AirImportAlertReminderEmails'), id: '13' })
      }

      // 处理包含 'AE' 的情况
      if (this.from.lob.includes(SystemConstants.AE.code)) {
        list.push({ name: this.$t('SystemMaintenance.AirExportAlertReminderEmail'), id: '11' })
      }

      // 处理包含 'IE' 的情况
      if (this.from.lob.includes(SystemConstants.IE.code)) {
        list.push({ name: this.$t('SystemMaintenance.IntegratedAlertReminderEmails'), id: '14' })
      }

      // 处理包含 'RE' 或 'RI' 的情况
      if (this.from.lob.includes(SystemConstants.RE.code) || this.from.lob.includes(SystemConstants.RI.code)) {
        list.push({ name: this.$t('SystemMaintenance.RailwayAlertReminderEmail'), id: '12' })
      }

      // 添加通用项
      list.push(
        { name: this.$t('SystemMaintenance.BillOfLadingPrintProduction'), id: '6' },
        { name: this.$t('SystemMaintenance.FileHistory'), id: '7' },
        { name: this.$t('SystemMaintenance.ReminderEmail'), id: '15' }
      )

      return list
    },
    pushListMap:function(){
      const obj = {};
      this.pushList.map((item)=>{
        obj[item.id] = item.name;
      })
      return obj;
    },
    sopDataItems() {
      return SopUtil.sopDataItems(this.emailEditing.lob)
    },
    dataItems() {
      let allDataItems = []
      switch (this.emailEditing.lob) {
        case 'SE':
          allDataItems = SopDataItemConstants.SOP_DATA_ITEMS
          break
        case 'SI':
          allDataItems = SopDataItemConstants.SOP_DATA_ITEMS_SI
          break
        case 'AE':
          allDataItems = SopDataItemConstants.SOP_DATA_ITEMS_AE
          break
        case 'AI':
          allDataItems = SopDataItemConstants.SOP_DATA_ITEMS_AI
          break
        case 'RE':
          allDataItems = SopDataItemConstants.SOP_DATA_ITEMS_RE
          break
        case 'RI':
          allDataItems = SopDataItemConstants.SOP_DATA_ITEMS_RI
          break
        case 'IE':
          allDataItems = SopDataItemConstants.SOP_DATA_ITEMS_IE
          break
      }
      return allDataItems.filter(item => item.tab === this.dataItemTab)
    },
    showName() {
      if (this.dataItemTab) {
        const item = this.dataItemTabs.find(item => item.code === this.dataItemTab)
        if (!item) {
          return ''
        }
        return this.isZh ? item.chineseName : item.englishName
      }
      return ''
    },
    isBbSendDestinationPortAgent() {
      return this.emailEditing.pushLink === BB_SEND_DESTINATION_PORT_AGENT_STRING
    }
  },
  beforeMount() {
    const context = this
    this.documentManage.set('handlePreviewFile', function(value) {
      context.handlePreviewFile(value)
    })
  },
  async mounted() {
    await cache.load(cacheName.CONFIG)
    this.storageURL = cache.config.get('StorageURL')
    let url = this.storageURL
    if (this.storageURL.substr(this.storageURL.length - 1, 1) === '/') {
      url = this.storageURL.slice(0, this.storageURL.length - 1)
    }
    this.uploadInfo.action = `${url}${URL.common.uploadStorage}`
    this.getListData()
    this.initDataItemTabs()
    this.initEmailGroupList()
    await getDocCategoryTypeTree().then(res => {
      this.docTypeMap = new Map()
      res.data.forEach(item => {
        const pathArr = item.path.split(',')
        if (item.type === 2 && pathArr.length > 1) {
          this.docTypeMap.set(item.code.toUpperCase(), item.chineseName)
        }
      })
    })
    setTimeout(() => {
      window.addEventListener('click', this.clickOther)
    }, 100)

  },
  beforeDestroy() {
    this.documentManage.destory()
  },
  methods: {
    // 下拉框选中
    selectItem(item) {
      this.dataItemTab = item.code
      this.chooseId = ''
    },
    // 展开下拉框
    spread() {
      if (this.isShow) {
        this.isShow = false
      } else {
        this.isShow = true
        this.chooseId = ''
      }
    },
    // 数据项选择
    chooseItem(index){
      const self = this;
      const btnContent = self.sopDataItems[Number(index)]
      this.onClickSopDataItemByContent(btnContent, index)
    },
    handlePreviewFile(id) {
        return `${URL.common.findByFileId}/${id}?sessionId=${this.$store.getters.token}`
    },
    // 富文本图片上传前
    beforeUpload(file) {
      this.quillUpdateImg = true
      const size = file.size;
      const imgSize = 20 *1024 *1024;
      if(size > imgSize){
        this.$message.warning('上传图片不能大于20MB')
        return
      }
    },
    uploadSuccess(res) {
      // 获取富文本组件实例
      let quill = this.$refs.myQuillEditor.quill
      // 如果上传成功
      if (res.ok) {
          const handlePreviewFile = this.documentManage.getPath('handlePreviewFile')
          let preview = `<a onclick="${handlePreviewFile}('${res.data}')" style="color:blue">${this.$t('FileHistory.preview')}</a>`
          // 获取光标所在位置
          let length = quill.getSelection().index;
          // 插入图片  res.info为服务器返回的图片地址
          let url = this.handlePreviewFile(res.data)
          quill.insertEmbed(length, 'image', url)
          // 调整光标到最后
          quill.setSelection(length + 1)
      } else {
          this.$message.error('图片插入失败')
      }
      // loading动画消失
      this.quillUpdateImg = false
    },
    blurEvent(e){
      this.blurIndex = e.srcElement.selectionStart;
    },
    statusChange() {
      if (this.checkList.length > 1) {
        this.checkList.splice(0, 1)
      }
    },
    // 鼠标双击列表行，打开编辑
    onCellDoubleClicked(itemData){
      if(this.$checkPermission(['role_emailTemplate_editable'])){
        this.chooseId = '';
        // 选中项的数据
        this.emailEditing = {...itemData.data};
        this.contrastData = JSON.stringify(this.emailEditing)
        this.emailEditingAccording = true
        this.convertFileCategoryLabel()
        this.isShow = false
        this.dataItemTab = 1
      }
    },
    async convertFileCategoryLabel() {
      this.masterFileCategoryLabel = ''
      this.slaveFileCategoryLabel = ''
      await ensureExecuteSuccess(() => !!this.docTypeMap)
      const { masterAttachItems, slaveAttachItems, attachItems } = this.emailEditing
      if (masterAttachItems) {
        this.masterFileCategoryLabel = Array.from(masterAttachItems.split(','), p => this.docTypeMap.get(p.toUpperCase())).join(',')
      }
      if (slaveAttachItems) {
        this.slaveFileCategoryLabel = Array.from(slaveAttachItems.split(','), p => this.docTypeMap.get(p.toUpperCase())).join(',')
      }
      if (attachItems) {
        this.fileCategoryLabel = Array.from(attachItems.split(','), p => this.docTypeMap.get(p.toUpperCase())).join(',')
      }
    },
    toAdd() {
      const self = this
      self.chooseId = '';
      self.emailEditing = {
        uuid: '',
        lob: 'SE',
        pushLink: '',
        themeTemplate: '',
        templateName: '', // 模板名称
        contentTemplate: '',
        dataItemList: [],
        multipleOfficeIdList: [],
        multipleAccountIdList: [],
        sales: false,
        op: false,
        csr: false,
        doc: false,
        siteOP: false,
        overseaOp: false,
        planner: false,
        userDefinedRoleId1: false,
        userDefinedRoleId2: false,
        emailGroup: false,
        emailGroupCcList: [],
        masterAttachItems: '',
        includeSlaveAttach: false,
        autoGenerationManifest: false,
        slaveAttachItems: '',
        hblBlWayAttach: false,
        hblWithoutGenerateAttach: false,
        confirmedPrintHbl: false,
        businessIfVirtualBillAsAttachment: false,
        hblCfmStateOriginDraft: false,
        whenBillNotStartWithoutAttachment: false,
        sendLockSlaveHblAndVirtualBill: false,
        sendLockExchangeAgentHblAndVirtualBill: false,
        autoPrintManifestAfterAllHblConfirm: false,
        businessIfVirtualBillOnlyAttachment: false,
        sendLockHblAndVirtualBill: false,
        takeWhenHasCustomerBillConfirm: true,
        takeWhenHasCustomerBillNotConfrim: true,
        autoPrintWhenNoneCustomerBillConfirm: true,
        mailServerType: 0
      }
      self.contrastData = JSON.stringify(self.emailEditing)
      self.emailEditingAccording = true
      this.convertFileCategoryLabel()
      this.isShow = false
      this.dataItemTab = 1
      this.isEdit = 0
    },
    // 编辑
    toView() {
      const self = this
      self.chooseId = '';
      getGridSelectedIds(self.gridOptions).then(ids => {
        // 选中项的数据
        if(ids.length > 1){
          this.$message.warning('只允许查看/编辑一条邮件模板')
        }else{
          self.emailEditing = { ...getGridSelected(self.gridOptions)[0] }
          console.log('self.emailEditing.autoPrintWhenNoneCustomerBillConfirm')
          console.log(self.emailEditing.autoPrintWhenNoneCustomerBillConfirm)
          console.log(self.emailEditing.autoPrintWhenNoneCustomerBillConfirm)
          self.contrastData = JSON.stringify(self.emailEditing)
          self.emailEditingAccording = true
          this.convertFileCategoryLabel()
          this.isShow = false
          this.dataItemTab = 1
          this.isEdit = 1
        }

      })
    },
    toDelete() {
      const self = this
      self.chooseId = '';
      getGridSelectedIds(self.gridOptions, 'uuid').then(ids => {
        // 选中项的数据
        if (ids.length > 0) {
          this.$confirm(this.$t('CargoMsg.Cargo_DeleteEmailTip'), this.$t('common.tips.prompt'), {
            confirmButtonText: this.$t('common.btn.ok'),
            cancelButtonText: this.$t('common.btn.cancel'),
            type: 'warning'
          }).then(() => {
            userApi.deleteMailTemplate(ids).then(res => {
              if (res.ok) {
                this.$message.success(this.$t('Message.DeleteSuccessfully'))
                this.getListData()
              }
            })
          })
        } else {
          this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectData'))
        }
      })
    },
    // 发送测试
    async emailSendTest(){
      const self = this;
      const loading = getLoading()
      switch(self.checkList[0]){
        case '系统邮箱':
          self.emailId = '0';
          break;
        case '公司邮箱':
          self.emailId = '1';
          break;
        case '个人邮箱':
          self.emailId = '2';
          break;
      }
      const data = {
        branchId: self.$store.getters.currentOfficeId,
        userId: self.emailEditing.modifiedBy,
        mailType: self.emailId,
        toEmailAddress: self.sendTestVal,
        pushLink: self.emailEditing.pushLink,//推送环节
        themeTemplate: self.emailEditing.themeTemplate,//主题模板
        templateName: self.emailEditing.templateName,//模板名称
        contentTemplate: self.emailEditing.contentTemplate
      }
      const receivedData = await userApi.templateSendTest(data).then(res=>res.ok).finally(() => {
        loading.close();
      })
      if(receivedData){
        self.secondaryConfirmation = false;
        self.$message.success('发送成功！')
        loading.close();
      }

    },
    keyUp() {
      this.cursor = this.myQuillEditor.selection.savedRange.index
    },
    onEditorFocus() {
      this.eFocus = this.constant.eFocus.emailContent
      this.cursor = this.myQuillEditor.selection.savedRange.index
    },
    // 列表数据请求
    async getListData(){
      const self = this;
      const data = {
        multipleOfficeIdList: this.from.multipleOfficeIdList,
        lob: this.from.lob,
        pushLink: this.from.pushLink,
        multipleAccountIdList: this.from.multipleAccountIdList,
        likeCondition:self.from.val.trim(),
        branchId: self.$store.getters.currentOfficeId,
      }
      const receivedData = await userApi.getMailTemplateByParams(data).then(res=>res.data)
      if (receivedData) {
        receivedData.forEach((item) => {
          item.dataItemList = (item.dataItem).split(',')
          item.pushLinkName = self.pushListMap[item.pushLink]
          // 设置对象中文名称
          if (item.multipleAccountId) {
            const accountIds = (item.multipleAccountId).split(',')
            item.multipleAccountIdList = []
            item.multipleAccountIdName = ''
            for (const accountId of accountIds) {
              item.multipleAccountIdName += (item.multipleAccountIdName ? ',' : '') + ColumnUtils.emailAccountLabelFunc(Number(accountId))
              item.multipleAccountIdList.push(Number(accountId))
            }
          }
          if (item.multipleOfficeId) {
            const officeIds = (item.multipleOfficeId).split(',')
            item.multipleOfficeIdName = ''
            item.multipleOfficeIdList = []
            for (const officeId of officeIds) {
              item.multipleOfficeIdName += (item.multipleOfficeIdName ? ',' : '') + ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', Number(officeId), 'code')
              item.multipleOfficeIdList.push(Number(officeId))
            }
          }
          if (item.emailGroupCc) {
            item.emailGroupCcList = (item.emailGroupCc).split(',')
          }
        })
        self.rowData = receivedData;
      }
    },
    // 保存修改
    async saveChanges(){
      const self = this;
      const data = {
        pushLink:self.emailEditing.pushLink,//推送环节
        lob:self.emailEditing.lob,//业务类型
        themeTemplate:self.emailEditing.themeTemplate,//主题模板
        contentTemplate:self.emailEditing.contentTemplate,//正文模板
        branchId: self.$store.getters.currentOfficeId,
        pushLinkName:self.emailEditing.pushLinkName,//推送环节名称
        templateName:self.emailEditing.templateName,//模板名称
        masterAttachItems:self.emailEditing.masterAttachItems,
        attachItems:self.emailEditing.attachItems,
        includeSlaveAttach:self.emailEditing.includeSlaveAttach,
        slaveAttachItems:self.emailEditing.slaveAttachItems,
        hblBlWayAttach:self.emailEditing.hblBlWayAttach,
        hblWithoutGenerateAttach:self.emailEditing.hblWithoutGenerateAttach,
        hblCfmStateOriginDraft:self.emailEditing.hblCfmStateOriginDraft,
        autoGenerationManifest:self.emailEditing.autoGenerationManifest,
        confirmedPrintHbl:self.emailEditing.confirmedPrintHbl,
        businessIfVirtualBillAsAttachment: self.emailEditing.businessIfVirtualBillAsAttachment,
        whenBillNotStartWithoutAttachment: self.emailEditing.whenBillNotStartWithoutAttachment,
        sendLockSlaveHblAndVirtualBill: self.emailEditing.sendLockSlaveHblAndVirtualBill,
        sendLockExchangeAgentHblAndVirtualBill: self.emailEditing.sendLockExchangeAgentHblAndVirtualBill,
        autoPrintManifestAfterAllHblConfirm: self.emailEditing.autoPrintManifestAfterAllHblConfirm,
        businessIfVirtualBillOnlyAttachment: self.emailEditing.businessIfVirtualBillOnlyAttachment,
        multipleOfficeIdList:self.emailEditing.multipleOfficeIdList,
        multipleAccountIdList:self.emailEditing.multipleAccountIdList,
        emailGroupCcList:self.emailEditing.emailGroupCcList,
        sales: self.emailEditing.sales,
        op: self.emailEditing.op,
        csr: self.emailEditing.csr,
        doc: self.emailEditing.doc,
        siteOP: self.emailEditing.siteOP,
        overseaOp: self.emailEditing.overseaOp,
        planner: self.emailEditing.planner,
        userDefinedRoleId1: self.emailEditing.userDefinedRoleId1,
        userDefinedRoleId2: self.emailEditing.userDefinedRoleId2,
        emailGroup: self.emailEditing.emailGroup,
        uuid:self.emailEditing.uuid,
        sendLockHblAndVirtualBill: self.emailEditing.sendLockHblAndVirtualBill,
        takeWhenHasCustomerBillConfirm: self.emailEditing.takeWhenHasCustomerBillConfirm,
        takeWhenHasCustomerBillNotConfrim: self.emailEditing.takeWhenHasCustomerBillNotConfrim,
        autoPrintWhenNoneCustomerBillConfirm: self.emailEditing.autoPrintWhenNoneCustomerBillConfirm,
        mailServerType: self.emailEditing.mailServerType
      }
      const receivedData = await userApi.saveMailboxTemplate(data).then(res=>res.data)
      if(receivedData){
        self.$message.success(this.$t('Message.SavedSuccessfully'))
        self.emailEditingAccording = false
        self.getListData()
      }
    },
    //确定
    determine(){
      this.secondaryConfirmation = true
      this.Title = "提示";
      this.dialogContent = {
        text:'是否确认修改后的内容？',
        id:2
      }

    },
    // 取消
    cancel() {
      this.Title = '提示';
      // 模板内是否有修改的内容，有则弹出二级弹窗
      const dataAfter = JSON.stringify(this.emailEditing)
      if(this.contrastData === dataAfter){
        this.emailEditingAccording = false;
      }else{
        this.secondaryConfirmation = true
        this.dialogContent = {
          text:'是否确认取消已填写/修改内容？',
          id:1
        }
      }
    },
    async checkData() {
      const data = {
        multipleOfficeIdList: this.emailEditing.multipleOfficeIdList,
        lob: this.emailEditing.lob,
        pushLink: this.emailEditing.pushLink,
        multipleAccountIdList: this.emailEditing.multipleAccountIdList,
        branchId: this.$store.getters.currentOfficeId,
        excludeUuid: this.emailEditing.uuid // 排除掉当前数据
      }
      return await userApi.getMailTemplateByParams(data).then(res=>res.data)
    },
   // CARGO-46770  邮箱模板管理 优化唯一性校验 只校验模板名称
    async checkMailData() {
      return await userApi.checkMailTemplateExist(this.emailEditing.templateName).then(res=>res.data)
    },
    // 二级弹窗确定
    async againDetermine(){
      if(this.Title === '提示'){
        if(this.dialogContent.id === 2){
          this.secondaryConfirmation = false
          if (!this.emailEditing.templateName) {
            this.$message.warning(this.$t('CargoMsg.Cargo_UpdateEmailTip'))
            return
          }
         /* const receivedData = await this.checkData()
          if (receivedData && receivedData.length > 0) {
            let multipleAccountIdName = ''
            if (this.emailEditing.multipleAccountId) {
              const accountIds = (this.emailEditing.multipleAccountId).split(',')
              for (const accountId of accountIds) {
                multipleAccountIdName += (multipleAccountIdName ? ',' : '') + ColumnUtils.emailAccountLabelFunc(Number(accountId))
              }
            }
            this.$message.warning(this.$t('CargoMsg.Cargo_UpdateEmailTip2', [this.pushListMap[this.emailEditing.pushLink], multipleAccountIdName]))
            return
          }*/
          const receivedData = await this.checkMailData()
          if (receivedData && this.isEdit === 0) {
            this.$message.warning(this.$t('CargoMsg.Cargo_UpdateEmailTip3',[this.emailEditing.templateName]))
            return
          }
          this.emailEditingAccording = false
          this.saveChanges();
        } else {
          this.secondaryConfirmation = false
          this.emailEditingAccording = false
        }
      }else{
        //发送测试
        if(!this.sendTestVal){
          this.$message.error('请填写收件邮箱！')
          return false;
        }
        else{
          this.emailSendTest();
        }
      }
    },
    // 二级弹窗取消
    confirmAgain(){
      this.secondaryConfirmation = false
    },
    // 发送测试
    async sendTest() {
      this.checkList = ['系统邮箱']
      this.sendEamilArr = ['系统邮箱']
      await this.getEamilStatus()
      this.sendTestVal = '';
      this.Title = '发送测试';
      this.secondaryConfirmation = true;
    },
    // 获取可用邮箱
    async getEamilStatus() {
      const data = {
        branchId: this.$store.getters.currentOfficeId,
        enable: 1
      }
      const personalInfo = await userApi.getPersonalEmail(data).then(resp => resp.data)
      if (personalInfo) {
        personalInfo.map((item) => {
          switch (item.mailType) {
            case '1':
              this.sendEamilArr.push(this.$t('SeaExport.CompanyMail'))
              break
            case '2':
              this.sendEamilArr.push(this.$t('SeaExport.PersonalMailbox'))
              break
          }
        })
      }
    },
    multipleLobChange() {
      if (this.from.pushLink && this.pushFilterList) {
        let has = false
        for (const data of this.pushFilterList) {
          if (data.id === this.from.pushLink) {
            has = true
          }
        }
        if (!has) {
          this.from.pushLink =''
        }
      }
    },
    changeDataItem(p) {
      if (!p.chineseName) {
        return
      }
      this.onClickSopDataItemByContent(p.value)
    },
    onClickSopDataItemByContent(btnContent, index) {
      // const self = this
      // const cursor = self.cursor//正文光标位置
      // let blurIndex = self.blurIndex//主题模板光标位置
      // let str = self.emailEditing.themeTemplate
      // this.chooseId = index;
      // if (self.eFocus === self.constant.eFocus.emailTitle) {
      //   self.emailEditing.themeTemplate = str.slice(0, blurIndex) + `\$\{${btnContent}\}` + str.slice(blurIndex);
      //   self.$refs['themeTemplate'].focus()
      // } else if (self.eFocus === self.constant.eFocus.emailContent) {
      //   self.myQuillEditor.insertEmbed(cursor, 'text', `\$\{${btnContent}}`)
      //   self.myQuillEditor.setSelection(cursor + 3 + btnContent.length)
      //   self.$nextTick(function() {
      //     self.myQuillEditor.blur()
      //   })
      // } else {
      //   self.$refs['myQuillEditor'].focus()
      //   self.eFocus = self.constant.eFocus.emailContent
      // }
      this.chooseId = index;
      let content = this.emailEditing.contentTemplate
      if (content) {
        const index = content.lastIndexOf('</')
        if (index > -1) {
          this.emailEditing.contentTemplate = content.substring(0, index) + `\$\{${btnContent}\}` + content.substring(index)
        } else {
          this.editor.focus(true) // 选区定位到最后
          this.editor.insertText(`\$\{${btnContent}\}`)
        }
      } else {
        this.emailEditing.contentTemplate = `<p>\$\{${btnContent}\}</p>`
      }
    },
    initDataItemTabs() {
      const allTabs = [...SopDataItemTabConstants.SOP_DATA_ITEM_TABS, ...SopDataItemTabConstants.SOP_DATA_ITEM_TABS_IE, ...SopDataItemTabConstants.SOP_DATA_ITEM_TABS_RI,
        ...SopDataItemTabConstants.SOP_DATA_ITEM_TABS_RE, ...SopDataItemTabConstants.SOP_DATA_ITEM_TABS_AI, ...SopDataItemTabConstants.SOP_DATA_ITEM_TABS_AE,
        ...SopDataItemTabConstants.SOP_DATA_ITEM_TABS_SI]
      const tabs = allTabs.filter(item => item.lob === this.emailEditing.lob)
      if (tabs && tabs.length > 0) {
        this.dataItemTab = tabs[0].code
      }
      this.dataItemTabs = tabs
    },
    onMasterSelectFileType() {
      this.fileTypeEditor.fileCategory = this.emailEditing.masterAttachItems
      this.fileTypeEditor.masterFlag = true
      this.fileTypeEditor.visible = true
    },
    onSalveSelectFileType() {
      this.fileTypeEditor.fileCategory = this.emailEditing.slaveAttachItems
      this.fileTypeEditor.masterFlag = false
      this.fileTypeEditor.visible = true
    },
    onSelectFileType() {
      this.fileTypeEditor.fileCategory = this.emailEditing.attachItems
      this.fileTypeEditor.visible = true
    },
    onSaveFileType(data) {
      if (this.isBbSendDestinationPortAgent) {
        this.emailEditing.attachItems = data.fileCategory
        this.fileCategoryLabel = data.fileCategoryLabel
        if (!this.emailEditing.attachItems) {
          this.emailEditing.hblBlWayAttach = false
          this.emailEditing.hblWithoutGenerateAttach = false
          this.emailEditing.hblCfmStateOriginDraft = false
        }
      } else {
        if (this.fileTypeEditor.masterFlag) {
          this.emailEditing.masterAttachItems = data.fileCategory
          this.masterFileCategoryLabel = data.fileCategoryLabel
        } else {
          this.emailEditing.slaveAttachItems = data.fileCategory
          this.slaveFileCategoryLabel = data.fileCategoryLabel
          if (!this.emailEditing.slaveAttachItems) {
            this.emailEditing.hblBlWayAttach = false
            this.emailEditing.hblWithoutGenerateAttach = false
            this.emailEditing.hblCfmStateOriginDraft = false
          }
        }
      }
    },
    onHblBlWayAttachChange() {
      if (this.isBbSendDestinationPortAgent) {
        if (!this.emailEditing.attachItems) {
          this.$nextTick(() => {
            this.emailEditing.hblBlWayAttach = false
          })
          this.$message.warning(this.$t('SystemMaintenance.PleaseSetAttach'))
        }
      } else {
        if (!this.emailEditing.slaveAttachItems) {
          this.$nextTick(() => {
            this.emailEditing.hblBlWayAttach = false
          })
          this.$message.warning(this.$t('SystemMaintenance.PleaseSetSlaveAttach'))
        }
      }
    },
    toNumArray(txt) {
      if (txt) {
        return Array.from(txt.split(','), p => Number(p))
      }
      return []
    },
    toTxt(str) {
      if (str && str.length > 0) {
        return str.join(',')
      }
      return ''
    },
    // 获取当前用户有权限的群组
    async initEmailGroupList() {
      const params = {
        checkOwner: this.$checkPermission(['role_MailGroup_userSelf']), // 查看自己的数据及公共的数据
        checkAll: this.$checkPermission(['role_MailGroup_all']) // 查看全部数据
      }
      await getMailGroupList(params).then(res => {
        const emailGroupList = res.data.list
        if (!emailGroupList || emailGroupList.length <= 0) return
        for (const group of emailGroupList) {
          if (group.groupSceneCc) {
            this.emailGroupCcList.push(group)
          }
        }
      })

      const data = {
        mailType: '1',
        branchId: this.$store.getters.currentOfficeId
      }
      const personalInfo = await userApi.getPersonalEmail(data).then(resp => resp.data)
      if (personalInfo) {
        this.branchEmail = personalInfo[0]
      } else {
        this.branchEmail = {}
      }
    },
    pushListChange() {
      // 目的港代理特殊处理，仅能选择 起运港/目的港代理
      if (this.emailEditing.pushLink === '16' || this.emailEditing.pushLink === '17' || this.isBbSendDestinationPortAgent) {
        this.emailEditing.multipleAccountIdList = [MAIL_ACCOUNT_5.code]
      }
      // 海运出口MBL HBL 邀请对单默认 客户
      if (this.emailEditing.pushLink === '2' || this.emailEditing.pushLink === '3') {
        this.emailEditing.multipleAccountIdList = [MAIL_ACCOUNT_1.code]
      }
    },
    onHblWithoutGenerateAttachChange() {
      if (this.isBbSendDestinationPortAgent) {
        if (!this.emailEditing.attachItems) {
          this.$nextTick(() => {
            this.emailEditing.hblWithoutGenerateAttach = false
          })
          this.$message.warning(this.$t('SystemMaintenance.PleaseSetAttach'))
        }
      }
      else {
        if (!this.emailEditing.slaveAttachItems) {
          this.$nextTick(() => {
            this.emailEditing.hblWithoutGenerateAttach = false
          })
          this.$message.warning(this.$t('SystemMaintenance.PleaseSetSlaveAttach'))
        }
      }
    },
    lobChange() {
      // lob切换时，重新设置下拉框数据
      this.initDataItemTabs()
    },
    onAutoGenerationManifest() {
      if (!this.emailEditing.autoGenerationManifest) {
        this.emailEditing.autoPrintManifestAfterAllHblConfirm = false
      }
    },
    onBusinessIfVirtualBillAsAttachment() {
      if (this.emailEditing.pushLink === '16') {
        if (this.emailEditing.businessIfVirtualBillAsAttachment) {
          this.emailEditing.businessIfVirtualBillOnlyAttachment = true
        } else {
          this.emailEditing.businessIfVirtualBillOnlyAttachment = false
        }
      }
    },
    clickOther(e) {
      if (e && this.isShow && this.$refs.dataItemTabs && !this.$refs.dataItemTabs.contains(e.target)) {
        this.isShow = false
      }
    },
    dataItemFocusEvent() {
      if (this.isShow) {
        this.isShow = false
      }
    }
  }
}
</script>
<style scoped lang="scss">
.main-content {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  .grid-wrapper{
    display: flex;
    flex-grow: 1;
    min-height: 200px;
  }
}
.edit-email-title {
  content: '';
  position: absolute;
  width: 4px;
  height: 13px;
  left: 40px;
  bottom: 0;
  background-color: #1F75D5;
}
.outside{
  width: 100px;
  height:28px;
  border-radius:2px;
  border: 1px solid #ccc;
  position:relative;
  margin-right: 10px;
  .outside-value{
    height: 30px;
    padding-left: 5px;
    cursor:pointer;
  }
  .operation{
    position:absolute;
    left:0;
    top:35px;
    display: flex;
    flex-direction: column;
    width:150px;
    border: 1px solid #ccc;
    background-color: #fff;
    border-radius:2px;
    .item{
      cursor: pointer;
      line-height: 30px;
      padding:0 5px;
      margin:2px 0;
      box-sizing:border-box;
      &:hover{
        color:#000000;
        background-color: #C3CCE7;
      }
      .dataItem{
        display: flex;
        justify-content: start;
        position:absolute;
        flex-wrap: wrap;
        height: 110px;
        width: 430px;
        background: #fff;
        right: -440px;
        top:0;
        border: 1px solid #ccc;
        overflow-y: scroll;
        padding: 5px;
        box-sizing: border-box;
        .item{
          padding: 0 10px;
          min-width:50px;
          height:30px;
          text-align: center;
          line-height: 30px;
          color: #000000;
          border-radius: 3px;
          border: 1px solid #cccccc;
          font-size: 12px;
          display: inline-block;
          margin:0 5px 5px 0;
          cursor: pointer;
          &:hover{
            background: #FFFFFF;
            border-color: #1F75D5;
            color: #1F75D5;
          }
        }
      }
    }
  }
  .set-color{
    color:#000000;
    background-color: #C3CCE7;
  }
  .icon{
    position: absolute;
    right: 5px;
    top: 27%;
    transform: translateY(-60%);
    pointer-events: none;
    cursor: pointer;
  }
  .rotatingShow{
    transform: rotate(180deg);
    transition: all 0.2s ease 0s;
  }
  .rotatingHide{
    transform: rotate(0deg);
    transition: all 0.2s ease 0s;
  }
}

.itemChoose{
  color: #FFFFFF !important;
  background-color: #1F75D5 !important;
  border-color: #1F75D5 !important;
  &:hover{
    color: #FFFFFF !important;
    background-color: #1F75D5 !important;
    border-color: #1F75D5 !important;
  }
}

.dataItems{
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  height:100px;
  overflow-y: scroll;
  .item{
    border-radius: 3px;
    border: 1px solid #ccc;
    padding: 0 5px;
    margin:0 5px 5px 0;
    height: 30px;
    line-height: 30px;
    font-size: 12px;
    display: inline-block;
    text-align: center;
    cursor: pointer;
    &:hover{
      background: #FFFFFF;
      border-color: #1F75D5;
      color: #1F75D5;
    }
  }
}
.checkbox-multiple /deep/ .el-checkbox__label {
  vertical-align: top;
  margin-top: 3px;
}
</style>

